import { Badge } from "@chakra-ui/react";
import { ImportReportIssueModel } from "../clients/BackOfficeApi";
import { useMemo } from "react";
import {
  escapeWithExtraSingleQuote,
  getArgumentDictionary,
  getDynamicMessageId,
} from "../components/I18n";
import { FormattedMessage } from "react-intl";

export function Issue({ issue }: { issue: ImportReportIssueModel }) {
  const {
    level,
    message,
    messageTemplate,
    arguments: messageArguments,
  } = issue;

  const blockingAwareLevel = useMemo(
    () => (message?.includes("Unexpected") ? "Unexpected-value" : level),
    [message, level],
  );

  const escapedMessage = useMemo(
    () => escapeWithExtraSingleQuote(messageTemplate ?? message),
    [messageTemplate, message],
  );
  const messageId = getDynamicMessageId(escapedMessage);
  const metadata = useMemo(
    () => getArgumentDictionary(escapedMessage, messageArguments),
    [escapedMessage, messageArguments],
  );

  return (
    <>
      <Badge>
        <FormattedMessage defaultMessage={blockingAwareLevel} id={`issue.level.${blockingAwareLevel}`} />
      </Badge>
      :{" "}
      <FormattedMessage
        defaultMessage={message}
        id={messageId}
        values={metadata}
      />
    </>
  );
}
